import SuccessfulLogin from './successful-login';
export default SuccessfulLogin;
